import * as Sentry from "@sentry/react";

/**
 * For more information on Sentry's configuration options, see:
 * https://docs.sentry.io/platforms/javascript/guides/react/
 */

Sentry.init({
  environment: import.meta.env.VITE_SENTRY_ENV,
  dsn: "https://8faab698381ea06021be5294625066dd@o280551.ingest.us.sentry.io/4507748652482560",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  /* Disabled for local development */
  enabled:
    import.meta.env.MODE !== "development" &&
    import.meta.env.SENTRY_ENABLED === "true",
});
